var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCnh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 100 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_1288",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 75
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H94C97.3137 0 100 2.68629 100 6V69C100 72.3137 97.3137 75 94 75H6C2.68629 75 0 72.3137 0 69V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_1288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H100V75H0V0Z",
    fill: "#E22613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9198 18.9481L19.3537 11.0519L16.7924 18.9481H8.49054L15.2028 23.8255L12.6415 31.7217L19.3537 26.8396L26.0707 31.7217L23.5047 23.8255L30.2217 18.9481H21.9198Z",
    fill: "#FEE400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 8.00006H41.0001V14.0001H35.0001V8.00006Z",
    fill: "#FEE400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0001 16.0001H49.0001V22.0001H43.0001V16.0001Z",
    fill: "#FEE400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0001 26.0001H49.0001V32.0001H43.0001V26.0001Z",
    fill: "#FEE400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0001 34.0001H41.0001V40.0001H35.0001V34.0001Z",
    fill: "#FEE400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 0C97.3137 0 100 2.68629 100 6V69C100 72.3137 97.3137 75 94 75H6C2.68629 75 0 72.3137 0 69V6C0 2.68629 2.68629 0 6 0H94ZM6 6V69H94V6H6Z",
    fill: "black",
    fillOpacity: 0.08
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCnh);
export default __webpack_public_path__ + "static/media/CNH.5b07c507258ddd12a9aa0535749eed41.svg";
export { ForwardRef as ReactComponent };